var _a;
import { LogLevel } from '../types';
var red = {
    web: '#ff0000',
    node: '\x1b[31m',
};
var yellow = {
    web: '#d7af00',
    node: '\x1b[33m',
};
var blue = {
    web: '#0000ff',
    node: '\x1b[34m',
};
var green = {
    web: '#5faf5f',
    node: '\x1b[32m',
};
var magenta = {
    web: '#FF00FF',
    node: '\x1b[35m',
};
var colorMap = (_a = {},
    _a[LogLevel.error] = red,
    _a[LogLevel.warn] = yellow,
    _a[LogLevel.info] = blue,
    _a[LogLevel.debug] = green,
    _a[LogLevel.trace] = magenta,
    _a);
export default colorMap;
//# sourceMappingURL=colors.js.map